import { Hint, InlineCode } from '@nejcm/docz-theme-extended';
import submenuPic from "../../../../../public/assets/submenu.jpg";
import * as React from 'react';
export default {
  Hint,
  InlineCode,
  submenuPic,
  React
};